module.exports = __webpack_public_path__ + "img/12.ac79c692.png";